import { GetContextMenuItemsParams, MenuItemDef } from 'ag-grid-community'
import { openDecisionPage } from 'utils/navigationHelper'
import DecideIconDisable from 'assets/icons/decide-menu-disable.svg'
import DecideIcon from 'assets/icons/decide-menu.svg'
import { ApprovalDeal } from 'ts/interfaces/approvalDeal.interface'

/**
 * Creates a "Decide" menu item for the row context menu.
 * @param params - AG Grid context menu parameters
 * @returns Menu item definition for decide action
 */
export const decideMenuItem = (params: GetContextMenuItemsParams): MenuItemDef => {
  const deal = params.node?.data as ApprovalDeal | undefined
  const dealId = deal?.dealNr ?? ''
  const hasDecisionPagePath = Boolean(deal?.decisionPagePath?.trim())
  const canDecide = Boolean(dealId && hasDecisionPagePath)
  const icon = canDecide ? DecideIcon : DecideIconDisable

  return {
    name: 'Decide',
    action: () => {
      if (canDecide) {
        openDecisionPage(deal!)
      }
    },
    icon: `<img src="${encodeURI(icon)}" alt="Decide" role="img" aria-label="Decide action icon" onerror="this.style.display='none'" />`,
    disabled: !canDecide,
  }
}
